export default __webpack_public_path__ + "static/media/improve.1420cda7.mp4";